var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "5.408 6 14.408 12 30 12 30 6 5.408 6",
    style: {
      fill: "#e03c31"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.408 24 30 24 30 18 14.408 18 5.408 24",
    style: {
      fill: "#001489"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0 9.605 0 20.395 8.092 15 0 9.605"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "0 8.163 0 9.605 8.092 15 0 20.395 0 21.837 10.255 15 0 8.163",
    style: {
      fill: "#ffb81c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30 16.8 16.208 16.8 14.045 16.8 3.245 24 5.408 24 14.408 18 30 18 30 16.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.408 12 5.408 6 3.245 6 14.045 13.2 16.208 13.2 30 13.2 30 12 14.408 12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.045 13.2 3.245 6 0 6 0 8.163 10.255 15 0 21.837 0 24 3.245 24 14.045 16.8 30 16.8 30 13.2 14.045 13.2",
    style: {
      fill: "#007749"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZa);
export default __webpack_public_path__ + "static/media/ZA.5ac0efb47724f2d90c84e78d0ec7b654.svg";
export { ForwardRef as ReactComponent };